import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'cs-user-registration-reject-reason',
    templateUrl: 'reject-reason.component.html'
})

export class UserRegistrationRejectReasonComponent implements OnInit {    
    formRejectReason: FormGroup;

    constructor(private activeModal: NgbActiveModal, private fb: FormBuilder) { }

    ngOnInit() {
        this.formRejectReason = this.fb.group({
            rejectionReason: [null, [Validators.required]]
        });
    }

    onSubmit() {
        this.activeModal.close(this.formRejectReason.getRawValue());
    }

    cancel() {
        this.activeModal.dismiss();
    }
}